import { STATUS_DESCRIPTION, taskIsErrored } from '#/models/jobs/task';
import { iterableJobTasks } from '#/models/jobs/snapshot';
import { TaskPhase, TaskStatus } from '#/protobuf/enums_pb';

// iterate all tasks to determine if error exists
export function jobIsErrored(job) {
  return iterableJobTasks(job.rootTasks).some((task) => taskIsErrored(task));
}

// determines if a job is completed
export function jobIsCompletedSuccessfully(job) {
  return job.aggregatePhase === TaskPhase.PHASE_DONE && job.aggregateStatus === TaskStatus.STATUS_NO_ERROR;
}

// aggregate status description across all tasks for a snapshot
export function jobStatusDescription(job) {
  // TODO: consolodate with status file. a lot of duplicated logic here.
  // if ANY task is errored show "errored"
  if (jobIsErrored(job)) {
    // short circuit out with "Errored" if applicable
    return STATUS_DESCRIPTION.ERRORED;
  }

  if (job.aggregatePhase === 0) {
    // 0 not allowed
    return STATUS_DESCRIPTION.UNKNOWN;
  }

  // else if ANY task is cancelled show "canceled"
  // else if ANY task is working show "working"
  // else if ANY task is paused show "paused"
  // else if ANY task is waiting show "waiting"
  // else if ALL tasks are done show "done"
  // else "unknown" - there is an undefined phase or a task with PHASE_NONE
  let canceled = 0;
  let done = 0;
  let working = 0;
  let paused = 0;
  let waiting = 0;
  let unknown = 0;
  let taskCount = 0;
  iterableJobTasks(job.rootTasks).forEach((task) => {
    taskCount += 1;
    switch (task.info.taskPhase) {
      case TaskPhase.PHASE_WAITING:
        waiting += 1;
        break;
      case TaskPhase.PHASE_PAUSED:
        paused += 1;
        break;
      case TaskPhase.PHASE_WORKING:
        working += 1;
        break;
      case TaskPhase.PHASE_CANCELED:
        canceled += 1;
        break;
      case TaskPhase.PHASE_DONE:
        done += 1;
        break;
      default:
        unknown += 1;
    }
  });
  if (canceled > 0) return STATUS_DESCRIPTION.CANCELED;
  if (working > 0) return STATUS_DESCRIPTION.WORKING;
  if (paused > 0) return STATUS_DESCRIPTION.PAUSED;
  if (waiting > 0) return STATUS_DESCRIPTION.WAITING;
  if (done === taskCount) {
    return STATUS_DESCRIPTION.DONE;
  }
  console.warn(`${unknown} tasks with unknown phases`);
  return STATUS_DESCRIPTION.UNKNOWN;
}
